import { en } from './en';
import { es } from './es';
import type { Messages } from './en';
import type { Locale } from '../locales';

export type { Messages } from './en';
export { en, es };

export const catalogs: Record<Locale, Messages> = {
  en,
  es,
};
